module.exports = __webpack_public_path__ + "static/media/YF19_3.c1a96147.jpg";